import { createSlice } from '@reduxjs/toolkit'

const ProjectSlice = createSlice({
    name: "Project",
    initialState: {
        projects: [],
        currentProject: {
            title: '',
            content: '',
            banner: '',
            author: '',
            publishDate: '',
            isDraft: true
        },
        isLoading: false,
        error: null,
        isSaving: false
    },
    reducers: {
        // Create/Save project actions
        saveProjectStart: (state) => {
            state.isSaving = true
        },
        saveProjectSuccess: (state, action) => {
            state.isSaving = false
            state.currentProject = action.payload
            state.error = null
        },
        saveProjectFailure: (state, action) => {
            state.isSaving = false
            state.error = action.payload
        },

        // Fetch projects actions
        fetchProjectsStart: (state) => {
            state.isLoading = true
        },
        fetchProjectsSuccess: (state, action) => {
            state.isLoading = false
            state.projects = action.payload
            state.error = null
        },
        fetchProjectsFailure: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },

        // Update current project
        updateCurrentProject: (state, action) => {
            state.currentProject = {
                ...state.currentProject,
                ...action.payload
            }
        },

        // Clear current project
        clearCurrentProject: (state) => {
            state.currentProject = {
                title: '',
                content: '',
                banner: '',
                author: '',
                publishDate: '',
                isDraft: true
            }
        }
    }
})

export const {
    saveProjectStart,
    saveProjectSuccess,
    saveProjectFailure,
    fetchProjectsStart,
    fetchProjectsSuccess,
    fetchProjectsFailure,
    updateCurrentProject,
    clearCurrentProject
} = ProjectSlice.actions

export default ProjectSlice.reducer